import {CalenderScheduleEvent} from '../../../Types/types';

export function eventIsValid(event: CalenderScheduleEvent) {
	if (event.start.day === '' || event.start.time.length === 0 || event.end.day === '' || event.end.time.length === 0) {
		return false;
	}
	if (event.start.day === event.end.day && event.start.time === event.end.time) {
		return false;
	}
	const [startHour, startMinute] = event.start.time.split(':').map(Number);
	const [endHour, endMinute] = event.end.time.split(':').map(Number);
	if (startHour === endHour && startMinute === endMinute) {
		return false;
	}
	return true;
}
